export const REQ_VEHICLES_SUCCES = "REQ_VEHICLES_SUCCES";
export const REQ_VEHICLES_ERROR = "REQ_VEHICLES_ERROR";
export const REQ_VEHICLES_ACTIVE_SUCCES = "REQ_VEHICLES_ACTIVE_SUCCES";
